/**
 * Photo Gallery Vue App
 * Initializes gallery instances wherever .photo-gallery-app is found
 */

import { createApp } from 'vue';
import PhotoGallery from './components/PhotoGallery.vue';

// Initialize Vue app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	// Find all gallery containers on the page
	const galleryContainers = document.querySelectorAll('.photo-gallery-app');

	if (galleryContainers.length === 0) {
		return;
	}

	// Initialize a Vue app for each gallery instance
	galleryContainers.forEach(container => {
		try {
			// Parse image data from data attribute
			const imagesData = container.dataset.images;

			if (!imagesData) {
				console.warn('Gallery container found but no image data provided');
				return;
			}

			const images = JSON.parse(imagesData);

			if (!Array.isArray(images) || images.length === 0) {
				console.warn('Gallery has no images');
				return;
			}

			// Get optional initial index
			const initialIndex = parseInt(container.dataset.initialIndex) || 0;

			// Create and mount Vue app
			const app = createApp(PhotoGallery, {
				images: images,
				initialIndex: initialIndex,
			});

			// Make WordPress data available if needed
			if (window.trendsData) {
				app.config.globalProperties.$wordpress = {
					ajaxUrl: window.trendsData.ajaxUrl || '/wp-admin/admin-ajax.php',
					nonce: window.trendsData.nonce || '',
					siteUrl: window.trendsData.siteUrl || '',
				};
			}

			app.mount(container);
		} catch (error) {
			console.error('Error initializing photo gallery:', error);
		}
	});
});
